'use strict';

var _templateObject = _taggedTemplateLiteralLoose(['\n    color: #808080;\n    background-color: #FFFFFF;\n    border-radius: 3px;\n    \n    &:hover,\n    &:focus {\n        background-color: #EEEEEE;\n    }\n'], ['\n    color: #808080;\n    background-color: #FFFFFF;\n    border-radius: 3px;\n    \n    &:hover,\n    &:focus {\n        background-color: #EEEEEE;\n    }\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _baseSignUpButton = require('../BaseButton/baseSignUpButton');

var _baseSignUpButton2 = _interopRequireDefault(_baseSignUpButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var React = require('react');
var createReactClass = require('create-react-class');
var LocalizeMixin = require('../../../../localization/CommonLocalizationMixin');

var GoogleSignUpButtonStyled = _styledComponents2.default.div(_templateObject);

var GoogleSignUpButton = createReactClass({
    displayName: 'GoogleSignUpButton',
    mixins: [LocalizeMixin],

    propTypes: {
        onClick: _propTypes2.default.func.isRequired
    },

    render: function render() {
        return React.createElement(
            GoogleSignUpButtonStyled,
            { className: 'sign-up-button google' },
            React.createElement(_baseSignUpButton2.default, { imageUrl: '/images/common/icons/ic_google_sign_up.png',
                buttonText: this.getLocalizedText("value_proposition_sign_up_google"),
                onClick: this.props.onClick })
        );
    }
});

module.exports = GoogleSignUpButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/loginComponents/SignUpButtons/Google/googleSignUpButton.js
// module id = 320
// module chunks = 0